function MiniBundle({ bundle, part }) {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#f3f4f6',
                borderRadius: 8,
                color: '#374151',
                fontSize: 12,
                padding: '6px 10px',
                gap: 4,
                border: '1px solid #e5e7eb',
                transition: 'all 0.2s ease',
                cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#e5e7eb';
                e.currentTarget.style.borderColor = '#d1d5db';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#f3f4f6';
                e.currentTarget.style.borderColor = '#e5e7eb';
            }}
            onClick={() => {
                window.open(`/editor/bundle/${bundle.id}`, '_blank');
            }}
            title={`${bundle.nom} - ${part}`}
        >
            <span style={{ 
                fontWeight: 600,
                color: '#6366f1',
                fontSize: 11,
            }}>{part[0].toUpperCase()}</span>
            <span style={{
                fontWeight: 500,
            }}>{bundle.shortName || bundle.nom}{bundle.subtitol ? ` (${bundle.subtitol})` : ''}</span>
        </div>
    );
}

export default MiniBundle;